import { useState, useRef, Fragment } from 'react';
import { CountUp } from 'use-count-up';
import dynamic from 'next/dynamic';
import Input from '../Input';
import { declOfNum } from '../../helpers';
import { submitClientRequest } from '../../helpers/clientRequest';
import { useLocationState } from '../../context/location';
import { useAppState } from '../../context/app';
import Textarea from '../Textarea';
import styles from '../../styles/modules/favorites/FavoritesStatistic.module.scss';
import FormAgreement from '../FormAgreement';

const Modal = dynamic(() => import('../Modal'));

const FavoritesStatistic = () => {
  const appState = useAppState();
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: window.location.pathname,
        whatComponent: 'FavoritesStatistic',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <>
      <Modal
        title="Обратная связь"
        button={!isSubmited && 'Отправить'}
        buttonDisabled={!agreeWithPolicy}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
            </div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем
              решить все имеющиеся у Вас вопросы!
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Хочу получить консультацию перед продажей своей квартиры в городе»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <section className={['block', styles.statistic].join(' ')}>
        <div className="fixed">
          <div className={styles.graph}>
            <div className={styles.graphPie}>
              <span className={styles.graphPieText}>
                <CountUp isCounting start={0} end={appState.history.length} duration={2} />
              </span>
              <svg className={styles.graphPieSVG} width="120" height="120">
                <circle r="45" cx="60" cy="60" style={{}} />
              </svg>
            </div>
            <div className={styles.graphContent}>
              <div className={styles.graphContentTitle}>Кол-во просмотров</div>
              <div className={styles.graphContentDescription}>
                Такое количество просмотров Вы совершили у нас на сайте. Из них{' '}
                <b>только {new Set(appState.history).size}</b>{' '}
                {declOfNum(new Set(appState.history).size, [
                  'уникальный объект',
                  'уникальные объекты',
                  'уникальные объекты'
                ])}
                !
              </div>
              <a
                role="button"
                tabIndex={0}
                className={styles.graphContentHelp}
                onClick={() => setIsModalVisible(true)}
              >
                Помочь с подбором объекта за 5 минут?
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FavoritesStatistic;
